/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/rewards';

/**
 * removeTalonRewards
 * url - /checkout/{apiversion}/cart/{cartId}/rewards?rewardId={rewardId}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.rewardId
 */
const removeTalonRewards = ({
    env,
    jwtToken,
    cartId,
    rewardId,
}) => {
    const envObj = {
        ...(env || {}),
        rootUri: `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`,
    };

    const params = {
        rewardId,
    };

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    return restClient.deleteRequest(envObj, resourcePage, jwtToken, null, params)
        .then((response) => response);
};

export default removeTalonRewards;
